<template>
  <el-row>
    <el-col :span="12">
      <template v-for="(form) in forms">
        <el-form-item
          size="small"
          :key="form.label"
          :prop="form.id"
          :label="form.label"
          :rules="form.rules"
        >
          <el-input
            v-if="form.type == 'text' || form.type == 'email' || form.type == 'number'"
            v-model="bodyLoyaltyItem[form.id]"
            :type="form.type"
            :placeholder="`Please input ${form.label}`"
          ></el-input>
          <el-select
            v-else-if="form.type == 'select'"
            v-model="bodyLoyaltyItem[form.id]"
            style="width: 100%"
            filterable
            remote
            :remote-method="form.onSearch"
          >
            <el-option
              v-for="item in form.data"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      
      <el-form-item size="small" prop="picture" label="Picture">
        <el-row>
          <el-image style="width: 100%; height: 260px" :src="bodyLoyaltyItem.imageURL" fit="contain"></el-image>
          <input
            style="display: none"
            type="file"
            placeholder="Please Input Payment Note"
            ref="fileInputPicture"
            accept="image/*"
            @change="e => onFilePicked(e, 'picture')"
          />

          <el-row type="flex" justify="center" class="mt-2">
            <el-col :span="12">
              <el-button
                type="primary"
                size="small"
                @click="onPickFile('picture')"
                style="width: 100%"
                :loading="loadingUploadBanner"
              >Upload</el-button>
            </el-col>
          </el-row>
        </el-row>
      </el-form-item>
    </el-col>

  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ApiService from "../../common/api.service";

export default {
  props: ["bodyLoyaltyItem", "from"],
  data() {
    return {
      limitKategory: 25,
      loadingUploadBanner: false
    };
  },
  methods: {
    ...mapActions({
      getLoyaltyItemCategory: "loyaltyItem/GetLoyaltyItemCategory",
    }),
    
    onPickFile() {
      this.$refs.fileInputPicture.click();
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      const body = {
        file: {
          base64: await this.toBase64(files[0])
        }
      };
      ApiService.init("heroku");
      this.loadingUploadBanner = true;
      const file = await ApiService.post("/v1/upload/banner", body); // perlu disesuaikan dengan relative url yang di-deploy
      this.loadingUploadBanner = false;
      fileReader.addEventListener("load", () => {
        this.bodyLoyaltyItem.imageURL = file.data.data.location;
      });
      fileReader.readAsDataURL(files[0]);
    }
  },
  computed: {
    forms() {
      return [
        {
          type: "text",
          id: "name",
          label: "Name",
          rules: [
            {
              required: true,
              message: "Name is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "number",
          id: "price",
          label: "Point",
          rules: [
            {
              required: true,
              message: "Point is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "text",
          id: "description",
          label: "Description",
          rules: [
            {
              required: true,
              message: "Description is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "select",
          id: "categoryKey",
          label: "Kategory",
          rules: [],
          data: this.loyaltyItemCategory.data
            ? this.loyaltyItemCategory.data.map(item => {
              item.name = `${item.value}`;
              item.value = item.key;
              return item;
            })
            : []
        },
      ];
    },
    ...mapState({
      loyaltyItemCategory: state => state.loyaltyItem.loyaltyItemCategory,
    })
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getLoyaltyItemCategory(option);
  }
};
</script>

<style>
</style>
